import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Index from "./pages/Index";
import IndexB from "./pages/IndexB";
import Parabens from "./pages/Parabens";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import TermosUso from "./pages/TermosUso";
import PoliticaReembolso from "./pages/PoliticaReembolso";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Criar SentryRoutes para rastreamento automático de navegação
const SentryRoutes = Sentry.withSentryRouting(Routes);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <SentryRoutes>
          <Route path="/" element={<Index />} />
          <Route path="/b" element={<IndexB />} />
          <Route path="/parabens" element={<Parabens />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-uso" element={<TermosUso />} />
          <Route path="/politica-reembolso" element={<PoliticaReembolso />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default Sentry.withProfiler(App);
